import React from 'react';
import { Map, TileLayer, Marker } from 'react-leaflet';
import './index.css';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/dist/styles.min.css';

class MapComponent extends React.Component {
  componentDidMount() {
    const map = this.refs.map.leafletElement;
    setTimeout(function() {
      map.invalidateSize();
    }, 0); // fix map displaing
  }

  render() {
    const { markers } = this.props;
    return (
      markers && (
        <Map
          id="Map"
          ref="map"
          center={[52.13, 21.02]} // Warsaw, PL
          zoom={5}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
          />
          <MarkerClusterGroup zoomToBoundsOnClick maxClusterRadius={50}>
            {markers.map((position, idx) => (
              <Marker
                key={`marker-${idx}`}
                position={position}
                id={idx}
                onClick={e => {
                  this.props.onClick(e);
                }}
              />
            ))}
          </MarkerClusterGroup>
        </Map>
      )
    );
  }
}

export default MapComponent;
